let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hb1wm")).then(() => parcelRequire('dYSoJ'));